import { render, staticRenderFns } from "./RelatorioJobView.vue?vue&type=template&id=9036cdde&scoped=true"
import script from "./RelatorioJobView.vue?vue&type=script&lang=js"
export * from "./RelatorioJobView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioJobView.vue?vue&type=style&index=0&id=9036cdde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9036cdde",
  null
  
)

export default component.exports